<template>
    <div :title="itemDate.full">
        <span v-if="isFuture() && futurePrefix" v-html="futurePrefix"></span>
        <span :class="{'text-orange': isFuture()}" >{{ formatDate(date) }}</span>
    </div>
</template>

<script>
import ZoiDate from "../../js/modules/ZoiDate";
export default {
    props: [
        'date',
        'direct',
        'futurePrefix',
        'ignoreFuture',
    ],
    data() {
        return {
            itemDate: new ZoiDate(this.date),
        };
    },
    methods: {
        isFuture() {
            return !this.ignoreFuture && this.itemDate.isFuture();
        },
        formatDate() {
            if (this.direct || this.isFuture()) {
                return this.itemDate.full;
            }

            return this.itemDate.relative;
        },
    },
}
</script>
